import React, { useState } from "react";
import styles from "./WeeklyLessonPlans.module.css";

import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import WeeklyLessonPlanRow from "../../components/WeeklyLessonPlanRow/WeeklyLessonPlanRow";
import Dropdown from "../../components/Dropdown/Dropdown";

import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { FaRegEdit } from "react-icons/fa";

const sampleLessons = [
  {
    id: 1,
    month: "June",
    day: "03",
    subject: "Maths",
    subjectColorVar: "Utility_Color1", // bare name -> resolves to --Utility_Color1
    opacity: 0.2,
    students: 1,
    notes: 1,
  },
  {
    id: 2,
    month: "June",
    day: "04",
    subject: "Maths",
    subjectColorVar: "Error_Color",
    opacity: 0.2, // was 5.25 (invalid) — now 0..1
    students: 1,
    notes: 1,
  },
  {
    id: 3,
    month: "June",
    day: "03",
    subject: "",
    subjectColorVar: "Primary_Color",
    opacity: 0.2,
    students: 0,
    notes: 0,
  },
  {
    id: 4,
    month: "June",
    day: "04",
    subject: "",
    subjectColorVar: "Utility_Color1", // removed leading -- to be consistent
    opacity: 0.01,
    students: 0,
    notes: 0,
  },
  {
    id: 5,
    month: "June",
    day: "04",
    subject: "Maths",
    subjectColorVar: "Utility_Color1",
    opacity: 0.7,
    students: 1,
    notes: 1,
  },
];

const WeeklyLessonPlans = () => {
  const [room, setRoom] = useState(null);
  const dispatch = useDispatch();

  const handleEditClick = () => {
    dispatch(openModal({ type: "chooseRange" }));
  };

  const handleRoomChange = (option) => {
    setRoom(option);
    console.log("Room changed to", option);
  };

  const handleAdd = (lesson) => {
    console.log("Add lesson for", lesson);
  };

  const handleShare = (lesson) => {
    console.log("Share lesson", lesson);
  };

  const handleDelete = (lesson) => {
    console.log("Delete lesson", lesson);
  };

  return (
    <div className={styles.container || ""}>
      <div className={styles.wrapper}>
        <div className={styles.rowWrapper}>
          <div
            className={styles.editWrapper}
            onClick={handleEditClick}
            style={{ cursor: "pointer" }}
          >
            <FaRegEdit size={18} />
            <span>This Month</span>
          </div>

          <Dropdown
            label="Rooms"
            options={["All Rooms", "Room A", "Room B"]}
            onChange={handleRoomChange}
            bgColor="var(--Primary_Color)"
          />
        </div>
        <div className={styles.rowBackground}>
          <div
          style={{
          
          }}
          >
            {sampleLessons.map((lesson) => (
              <WeeklyLessonPlanRow
                key={lesson.id}
                month={lesson.month}
                day={lesson.day}
                subject={lesson.subject}
                subjectColorVar={lesson.subjectColorVar}
                opacity={
                  typeof lesson.opacity === "number" ? lesson.opacity : 0.7
                }
                students={lesson.students}
                notes={lesson.notes}
                onAdd={() => handleAdd(lesson)}
                onShare={() => handleShare(lesson)}
                onDelete={() => handleDelete(lesson)}
              />
            ))}

            <div
              style={{ textAlign: "center", paddingTop: 12, color: "#b6c0c8" }}
            >
              1
            </div>
          </div>
        </div>

        <div style={{ marginTop: "1rem" }} className={styles.infoRow}>
          <div className={styles.circle}></div>
        </div>
      </div>
    </div>
  );
};

export default WeeklyLessonPlans;
